export enum USER_TYPE {
  employer = 'EMPLOYER',
  employee = 'EMPLOYEE',
  merchant = 'MERCHANT',
  student_body = 'STUDENT_BODY',
  admin = 'ADMIN',
}

export enum INVITE_STATUS {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
}

export enum SCHEDULED_STATUS {
  LIVE = 'LIVE',
  SCHEDULED = 'SCHEDULED',
  ENDED = 'ENDED',
}

export enum PERK_STATUS {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  LIVE = 'LIVE',
  SCHEDULED = 'SCHEDULED',
  ENDED = 'ENDED',
  ENDINGSOON = 'ENDINGSOON',
  PENDINGAPPROVAL = 'PENDINGAPPROVAL',
  DISAPPROVED = 'DISAPPROVED',
}

export enum PERK_SCHEDULE_STATUS {
  ENDED = 'ENDED',
  ENDINGSOON = 'ENDINGSOON',
  SCHEDULED = 'SCHEDULED',
  LIVE = 'LIVE',
}

export enum PERK_BRAND_LOGO {
  NO_LOGO = 'NO_LOGO',
  USE_PERK_LOGO = 'USE_PERK_LOGO',
  USE_PROFILE_LOGO = 'USE_PROFILE_LOGO',
}

export enum EMAIL_DOMAIN_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum PERK_REDEEM_STATUS {
  VERIFIED = 'verified',
  UNVERIFIED = 'unverified',
  PENDING = 'pending',
}

export enum ORDER_TYPE {
  PURCHASED = 'PURCHASED',
  FREE = 'FREE',
}

export enum UNAVAILABLE_ITEM_TYPE {
  OUT_OF_STOCK = 'out_of_stock',
  PER_USER_LIMIT_REACHED = 'per_user_limit_reached',
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  EXPIRED = 'expired',
  DELETED = 'deleted',
}

export enum GROUP_TYPE {
  SUPER_USERS = 'super_users',
  ALL_USERS = 'all_users',
}

export enum FORM_MODE {
  ADD = 'add',
  EDIT = 'edit',
  LIST = 'list',
}

export enum REDEEM_CODE_TYPE {
  TEXT = 'text',
  FILE = 'file',
  URL = 'url',
}

export enum ALLOWED_ACCESS_BECAUSE {
  MANUAL = 'MANUAL',
  EMAIL_FORMAT = 'EMAIL_FORMAT',
  NEW_SIGNUPS_EMPLOYEES = 'NEW_SIGNUPS_EMPLOYEES',
}
export enum PLATFORM {
  ANDROID = 'android',
  IOS = 'ios',
  WEB = 'web',
}
export enum VALIDATION_RULE {
  string = 'string',
  email = 'email',
  password = 'password',
  positiveInt = 'positiveInt',
  url = 'url',
}
export enum MOBILE_DATA_STORED_FROM {
  mobileBrowser = 'browser',
  mobileApp = 'app',
}

export enum TEST_ACCOUNTS_TYPE {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export enum INTEGRATION_APP {
  MICROSOFT_TEAMS = 'microsoft_teams',
  SLACK = 'slack',
  STRIPE = 'stripe',
}

export enum INTEGRATION_STATE {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  NOT_CONNECTED = 'not_connected',
}

export enum PERK_ACTION_ENUM {
  addEdit = 'add_edit',
  pubUnPub = 'pub_unpub',
  sendForApproval = 'send_for_approval',
}

export enum SORT_ORDER {
  ASCEND = 'ascend',
  DESCEND = 'descend',
}

export enum LOCATION_TYPE {
  point = 'Point',
  lineString = 'LineString',
  polygon = 'Polygon',
  multiPoint = 'MultiPoint',
}

export enum BUTTON_TYPE_ENUM {
  primary = 'primary',
  dashed = 'dashed',
  default = 'default',
  link = 'link',
  text = 'text',
}
export enum NotificationPermissions {
  granted = 'granted',
  denied = 'denied',
  default = 'default',
}

export enum APPROVAL_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DISAPPROVED = 'DISAPPROVED',
}

export enum USER_TYPE_FILTER {
  ALL = 'ALL',
  MADE_BY_ME = 'MADE_BY_ME',
  OWNER = 'OWNER',
  MERCHANT = 'MERCHANT',
  EMPLOYER = 'EMPLOYER',
  SUPER_USER = 'SUPER_USER',
  STANDARD_USER = 'STANDARD_USER',
  STUDENT_BODY = 'STUDENT_BODY',
  ADMIN = 'ADMIN',
}

export enum CAPTURE_METHOD {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
}

export enum BudgetStatusEnum {
  NOT_CLAIMED = 'NOT_CLAIMED',
  REQUESTED = 'REQUESTED',
  GRANTED = 'GRANTED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
  REFUNDED = 'REFUNDED',
}

export enum BUTTON_SIZE_ENUM {
  small = 'small',
  middle = 'middle',
  large = 'large',
}

export enum FLEX_ALIGN_ENUM {
  flexStart = 'flex-start',
  center = 'center',
  flexEnd = 'flex-end',
}

export enum FLEX_JUSTIFY_ENUM {
  flexStart = 'flex-start',
  center = 'center',
  flexEnd = 'flex-end',
  spaceBetween = 'space-between',
  spaceAround = 'space-around',
  spaceEvenly = 'space-evenly',
}

export enum CUSTOM_CATEGORY_IMAGE_TYPE {
  svg = 'svg',
  other = 'other',
}

export enum SELECTED_CATEGORY_TYPE {
  category = 'category',
  subcategory = 'subcategory',
}

export enum IMPORT_REDEEM_CODES_TYPE {
  file = 'file',
  csv = 'csv',
}

export enum REDEEM_CODE_TYPES {
  FILE = 'file',
  URL = 'url',
  TEXT = 'text',
}

export enum PlatformTypeEnum {
  web = 'web',
  android = 'android',
  ios = 'ios',
}

export enum RoleStatus {
  active = 'active',
  inactive = 'inactive',
  deprecated = 'deprecated',
}

export enum ApiResponseStatusEnum {
  success = 'success',
  error = 'error',
}

export enum PermissionCheckModeEnum {
  every = 'every', // user must have every permissions that have passed.
  any = 'any', // user must have any permissions that have passed.
}

/**
 * Enum to distinguish between frontend and backend environments.
 * This enum helps in conditionally setting types in shared interfaces based on the environment.
 */
export enum EnvironmentTypeEnum {
  frontend = 'frontend',
  backend = 'backend',
}
export enum DATA_STORED_FROM {
  mobileBrowser = 'mobile-browser',
  mobileApp = 'mobile-app',
}

export enum BUDGET_STATUS {
  NOT_CLAIMED = 'not claimed',
  REQUESTED = 'requested',
  GRANTED = 'granted',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  REFUNDED = 'refunded',
}

export enum EMPLOYEE_STATUS {
  ADDED = 'added',
  INVITED = 'invited',
  SIGNED_UP = 'signed_up',
}

export enum PERK_TYPE {
  PERK = 'perk',
  BENEFIT = 'benefit',
}

export enum FORM_ACTION {
  add = 'add',
  update = 'update',
}

export enum QueryKeyTypeEnum {
  id = 'id',
  roleIdentifier = 'roleIdentifier',
  defaultRoleForEmployer = 'defaultRoleForEmployer',
  defaultRoleForStudentBody = 'defaultRoleForStudentBody',
  defaultRoleForMerchant = 'defaultRoleForMerchant',
  defaultRoleForMerchantEmployee = 'defaultRoleForMerchantEmployee',
  defaultRoleForStudentBodyEmployee = 'defaultRoleForStudentBodyEmployee',
  defaultRoleForStudentBodySuperUser = 'defaultRoleForStudentBodySuperUser',
  defaultRoleForEmployerEmployee = 'defaultRoleForEmployerEmployee',
  defaultRoleForEmployerSuperUser = 'defaultRoleForEmployerSuperUser',
  defaultRoleForAdmin = 'defaultRoleForAdmin',
}

export enum BatchStatusEnum {
  completed = 'completed',
  failed = 'failed',
}

export enum MigrationStatusEnum {
  pending = 'pending',
  inProgress = 'inProgress',
  completed = 'completed',
  failed = 'failed',
}

export enum UserLogChangeTypeEnum {
  validationFailed = 'validationFailed',
  roleUpdate = 'roleUpdate',
  processingError = 'processingError',
}

export enum BatchDetailStatusEnum {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
}

export enum PermissionStatus {
  active = 'active',
  inactive = 'inactive',
  deprecated = 'deprecated',
}
